import {h, Fragment} from "preact"
export default function SubmitButton({ className, text, query }) {
    return (
        <h5 className={`ns-color-black ns-header ${className}`} style="text-align: right;">
            <button type="submit" className="ns-submit" onClick={(e) => { e.preventDefault(); window.location.href = `https://kentstreetcellars.com.au/search?q=${query}`}}>
                {text}
            </button>
        </h5>
    )
}